// extracted by mini-css-extract-plugin
export default {"image-detail-choose-style-task":"index_image-detail-choose-style-task__2M3rD"};